import { createHashRouter } from 'react-router-dom';

import { RootBoundary } from '../components/feedback/root-error-boundary.jsx';
import { NotFound } from '../pages/not-found.jsx';
import { Redirect } from '../pages/redirect.jsx';
import { authRoutes } from './auth/index.js';
import { backofficeRoutes } from './backoffice/index.js';
import { customerPortalRoutes } from './customer-portal/index.js';

const routerOptions = { basename: '/' };
const router = createHashRouter(
  [
    {
      path: '/',
      errorElement: <RootBoundary />,
      children: [
        { index: true, element: <Redirect /> },
        customerPortalRoutes,
        backofficeRoutes,
        authRoutes,
      ],
    },
    {
      path: '*',
      element: <NotFound />,
    },
  ],
  routerOptions,
);

export default router;
